import { Component, EventEmitter, Input, Output } from "@angular/core";
import { formatMessage } from "devextreme/localization";
import { ValueChangedEvent as NumberBoxChangedEvent } from "devextreme/ui/number_box";
import { ValueChangedEvent as SelectBoxChangedEvent } from "devextreme/ui/select_box";

export type SpineStampingOption = "None" | "10 sqn included" | "Stamping sqn";

/**
 * SpineStampingSelectComponent is responsible for presenting and managing the selection of spine stamping options
 * in the user interface. It provides the ability to select predefined options as well as manage additional data input
 * when required by the selected option.
 *
 * Inputs:
 * - optionId: A string value that represents the unique identifier of the current option being handled.
 *
 * Outputs:
 * - onValueChanged: An event emitter that outputs the selected or updated value, which can be a number or undefined.
 */
@Component({
  selector: "app-spine-stamping-select",
  templateUrl: "./spine-stamping-select.component.html",
  styleUrls: ["./spine-stamping-select.component.scss"],
})
export class SpineStampingSelectComponent {
  @Input() optionId: string | undefined;

  @Output() onValueChanged = new EventEmitter<number | undefined>();

  formatMessage = formatMessage;

  dataSource: SpineStampingOption[] = [
    "None",
    //"10 sqn included",
    "Stamping sqn",
  ];
  selectedSpineStamping: SpineStampingOption = "Stamping sqn";
  additionalSqn: number | undefined = 1;

  constructor() {}

  spineStampingChanged($event: SelectBoxChangedEvent) {
    const value = $event.value as SpineStampingOption;
    this.selectedSpineStamping = value;
    switch (value) {
      case "Stamping sqn":
        this.additionalSqn = 1;
        break;
      case "10 sqn included":
        this.additionalSqn = 0;
        break;
      case "None":
        this.additionalSqn = undefined;
        break;
    }
    this.onValueChanged.emit(this.additionalSqn);
  }

  additionalSqnChanged($event: NumberBoxChangedEvent) {
    const value = $event.value;
    if (this.selectedSpineStamping === "Stamping sqn") {
      this.additionalSqn = value;
      this.onValueChanged.emit(value);
    }
  }
}
